export default {
  data() {
    return {}
  },
  methods: {
    getTime: function(t, short) {
      let time = '';
      const h = Math.floor(t / 3600);
      const m = Math.floor(t % 3600 / 60);
      if (h > 0) {
        if (h > 1) {
          time = h + ' hrs';
        } else {
          time = h + ' hr';
        }
      }

      if (h > 0 && short) {
        return time;
      } else {
        if (m > 0) {
          time += ' ';
          if (m > 1) {
            time += m + ' mins';
          } else {
            time += m + ' min';
          }
        }
        return time;
      }
    },

    getDistance: function(d) {
      const k = (d / 1000) *  0.62137;
      if (d < 1000) {
        return Math.round(k * 10)/10 + ' mile';
      }
      // const k = d / 1000;
      // return Math.round(((k * 1000 * 0.62137) / 1000)) + ' m';
      return Math.round(k * 10)/10 + ' miles';
    },

    setIcons: function(steps) {
      steps.forEach(step => {
        let icon = step.maneuver.type.replace(/ /g, '_');
        if (step.maneuver.modifier) {
          icon += '_' + step.maneuver.modifier.replace(/ /g, '_');
        }
        step['icon'] = icon + '.svg';
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Common.js